import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@material-ui/core/styles';
import { usePostHog } from 'posthog-js/react';

import { Titles } from '../../Onboarding/components/Titles/Titles';

import { Product } from '@/utils/productHelpers';
import { SelectButton } from '@/components/Button';

type Props = {
  onMyself: () => void;
  onDependent: () => void;
};

type PreOnboardingParams = {
  slug: string;
  product: Product;
};

export const WhoAreYouEnrollingActivate: React.FC<Props> = ({
  onMyself,
  onDependent,
}) => {
  const theme = useTheme();
  const { product } = useParams<PreOnboardingParams>();
  const { t } = useTranslation();
  const posthog = usePostHog();

  const choiceBaseStyle: React.CSSProperties = useMemo(() => ({
    width: '100%',
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: 100,
    padding: '12px 16px',
    textTransform: 'none',
    fontWeight: 600,
    justifyContent: 'center',
    borderWidth: 1.5,
  }), []);

  return (
    <div style={{ marginBottom: '40px' }}>
      <Titles
        title={t(`coverage.${product}.person_enrolling.title`)}
        subtitle={t(`coverage.${product}.person_enrolling.subtitle`)}
      />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          gap: 12,
        }}
      >
        <SelectButton
          aria-pressed={false}
          style={choiceBaseStyle}
          onClick={() => {
            posthog?.capture('DependentSelected', { 'spark.dependent': 'no' });
            onMyself();
          }}
        >
          {t(`coverage.${product}.person_enrolling.myself`)}
        </SelectButton>

        <SelectButton
          aria-pressed={false}
          style={choiceBaseStyle}
          onClick={() => {
            posthog?.capture('DependentSelected', { 'spark.dependent': 'yes' });
            onDependent();
          }}
        >
          {t(`coverage.${product}.person_enrolling.dependent`)}
        </SelectButton>
      </div>
    </div>
  );
};

export default WhoAreYouEnrollingActivate;
